import { ChartPieOutlineIcon } from './ChartPieOutlineIcon';

/**
 * author: Google
 * id B7CE40ED-002C-475A-ADAC-8110FE260F65
 * name chart-pie-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-pie-outline.svg
 * tags
 * - Math 
 */
export const WidgetPieOutlineIcon = ChartPieOutlineIcon;
export default WidgetPieOutlineIcon